export const Types = {
  OPEN_ADD_RETARGETING_PIXEL_MODAL: "OPEN_ADD_RETARGETING_PIXEL_MODAL",
  ADD_RETARGETING_PIXEL: "ADD_RETARGETING_PIXEL",
  UPDATE_RETARGETING_PIXEL: "UPDATE_RETARGETING_PIXEL",
  OPEN_ADD_RETARGETING_PIGGYBACK_PIXEL_MODAL: "OPEN_ADD_RETARGETING_PIGGYBACK_PIXEL_MODAL",
  ADD_RETARGETING_PIGGYBACK_PIXEL: "ADD_RETARGETING_PIGGYBACK_PIXEL",
  GET_ALL_RETARGETING_PIXELS: "GET_ALL_RETARGETING_PIXELS",
  CLEAR_RETARGETING_PIXEL_STATES: "CLEAR_RETARGETING_PIXEL_STATES",
};
